import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput, SwitchInput } from '../../Form';
import { token } from "../../../libs/localStorage";
import { getDisplayDate } from '../../../libs/date';

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'rolePermissionStore')
@observer
class TicketEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = this.props.params.ticket_id ? `/station/${this.props.params.id}/maintenance/ticket` : '/monitoring/ticket';
  title = 'Edit Ticket';

  @observable item = {};
  @observable ticketClosed = false;

  @action onChangeStation = e => this.item.station_id = +e.target.value;
  @action onChangeSummary = e => this.item.summary = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeStatus = e => this.item.status_id = +e.target.value;
  @action onChangeReason = e => this.item.reason_id = +e.target.value;
  @action onChangeAction = e => this.item.action_id = +e.target.value;
  @action onChangeName = e => this.item.name = e.target.value;
  @action onChangeMobileNo = e => this.item.mobile_no = e.target.value;
  @action onChangeEmail = e => this.item.email_address = e.target.value;
  @action onChangeArchived = e => this.item.archived = !this.item.archived;

  constructor(props) {
    super(props);

    const { params: { id, ticket_id }, ticketStore } = this.props;

    ticketStore.fetchItem(ticket_id || id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id, ticket_id }, ticketStore } = this.props;
    const foundItem = ticketStore.findById(ticket_id || id);
    if (foundItem) {
      this.item = observable(Object.assign({}, foundItem.asJson));
      this.ticketClosed = !!this.item.archived;
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const { ticketStore, userStore, stationStore } = this.props;
    const { notify, router } = this.context;

    const sender = token.getDecoded();
    const follower = userStore.findById(this.item.assigned_to).asJson;
    const station = stationStore.findById(this.item.station_id).asJson;

    const {
      id,
      status_id,
      reason_id,
      action_id,
      user_id,
      summary,
      description,
      station_id,
      assigned_to,
      end_date,
      name,
      mobile_no,
      email_address,
      archived
    } = this.item;

    ticketStore.updateItem({
      id,
      status_id,
      reason_id,
      action_id,
      user_id,
      summary,
      description,
      station_id,
      assigned_to,
      end_date,
      name,
      mobile_no,
      email_address,
      sender: {
        name: sender.name,
        email: sender.email
      },
      follower: follower.email,
      station_name: station.name,
      origin: window.location.origin,
      archived
    }).then(() => {
      notify.success({ message: "Saved" })
      router.push(this.slug);
    }).catch((e) => notify.error({ message: e.toString() }));
  }

  render() {
    const { ticketStore, params: { id, ticket_id }, stationStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, rolePermissionStore } = this.props;

    const station = stationStore.findById(this.item.station_id);
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    return (
      <Modal title={this.title} slug={this.slug} isSaving={ticketStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput value={ticket_id || id} label='Ticket number' readOnly />

            <SelectInput
              label={'Status'}
              value={this.item.status_id}
              options={ticketStatusStore.items}
              onChange={this.onChangeStatus}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <SelectInput
              label={'Reason'}
              value={this.item.reason_id}
              options={ticketReasonStore.items}
              onChange={this.onChangeReason}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <SelectInput
              label={'Action'}
              value={this.item.action_id}
              options={ticketActionStore.items}
              onChange={this.onChangeAction}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <TextInput label='Summary' value={this.item.summary} onChange={this.onChangeSummary} />
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription} />

            {!this.props.station_id ? <SelectInput
              label={'Station'}
              value={this.item.station_id}
              options={stationStore.items}
              onChange={this.onChangeStation}
              fields={{
                label: 'name',
                value: 'id',
              }}
            /> : <TextInput label={'Station'} value={!!station ? station.name : ''} readOnly />}

            {hasUserPermission && <SelectInput
              label={'Assigned To'}
              value={this.item.assigned_to}
              options={userStore.items}
              onChange={this.onChangeAssignedTo}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />}

            {this.ticketClosed && <TextInput label='End Date' value={this.item.end_date ? getDisplayDate(this.item.end_date) : ''} readOnly />}

            <TextInput label='Name' value={this.item.name} onChange={this.onChangeName} />
            <TextInput label='Mobile No.' value={this.item.mobile_no} onChange={this.onChangeMobileNo} />
            <TextInput label='Email Address' value={this.item.email_address} onChange={this.onChangeEmail} />

            <div className='formInput'>
              <label>Archived</label>
              <input type="checkbox" checked={this.item.archived} onChange={this.onChangeArchived} />
            </div>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default TicketEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketEdit.js